import { createSelector } from 'reselect';

import { selectUnderwriting } from './underwriting.selectors';

export const selectSearchSynonyms = createSelector(
  selectUnderwriting,
  ({ searchSynonyms }) => searchSynonyms ?? [],
);
